import {INPUT_PARAM_CONSTRAINTS} from "../../components/InputsForm/constants";


const errorMessages = {
	vinMinRequired: 'Vin min is required',
	vinMaxRequired: 'Vin max is required',
	voutRequired: 'Vout is required',
	ioutRequired: 'Iout is required',
	ambientTemperatureRequired: 'Ambient Temperature is required',
	vinMinNumber: 'Vin min must be a valid number',
	vinMaxNumber: 'Vin max must be a valid number',
	vinNomNumber: 'Vin nom must be a valid number',
	voutNumber: 'Vout must be a valid number',
	ioutNumber: 'Iout must be a valid number',
	ambientTemperatureNumber: 'Ambient Temperature must be a valid number',
	vinMinInRange:
		'Vin min must be in range [' + INPUT_PARAM_CONSTRAINTS.VIN_MIN + ',' + INPUT_PARAM_CONSTRAINTS.VIN_MAX + ']',
	vinMaxInRange:
		'Vin max must be in range [' + INPUT_PARAM_CONSTRAINTS.VIN_MIN + ',' + INPUT_PARAM_CONSTRAINTS.VIN_MAX + ']',
	voutInRange:
		'Vout must be in range (' + INPUT_PARAM_CONSTRAINTS.VOUT_MIN + ',' + INPUT_PARAM_CONSTRAINTS.VOUT_MAX + ']',
	ioutInRange:
		'Iout must be in range (' + INPUT_PARAM_CONSTRAINTS.IOUT_MIN + ',' + INPUT_PARAM_CONSTRAINTS.IOUT_MAX + ']',
	ambientTemperatureInRange:
		'Ambient Temperature must be in range [' +
		INPUT_PARAM_CONSTRAINTS.AMB_TEMP_MIN +
		',' +
		INPUT_PARAM_CONSTRAINTS.AMB_TEMP_MAX +
		']',
	vinMinLoOrEqToVinMax: 'Vin min must be <= Vin max',
	vinMaxEqOrGrThanVinMin: 'Vin max must be >= Vin min',
	vinNomBetweenVinMinAndVinMax: 'Vin nom must be between Vin min and Vim max'
};

export default errorMessages;